import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Camera: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="6"
        width="20"
        height="14"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="12" cy="13" r="4" stroke={color} strokeWidth="2" />
      <path
        d="M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4H7Z"
        fill={color}
      />
    </svg>
  );
};

export default Camera;
